<div id="fulltab" [innerHTML]="content">
</div>
